import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { ExternalSettings } from 'src/app/common/services/external-settings/external-settings.interface';
import { ActivityTitle } from 'src/app/common/activities/me-meta';
import { ResponsiveDesignService } from 'src/app/common/services/responsive-design/responsive-design.service';
import { TranslateUtilityService } from 'src/app/system/utility/translation-utility.service';
import { InstructionData, TipsData } from '../me-tips.service';

@Component({
    selector: 'app-me-instructions-dialog',
    templateUrl: './me-instructions-dialog.component.html',
    styleUrls: ['./me-instructions-dialog.component.less'],
    standalone: false
})
export class MeInstructionsDialogComponent implements OnInit {
  externalSettings!: ExternalSettings;
  UIUtilityService: any = UIUtilityService;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ActivityTitle,
    private srvES: ExternalSettingsService,
    protected srvRpDesign: ResponsiveDesignService,
    private srvTranslate: TranslateUtilityService
  ) {}

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((externalSettings) => {
      this.externalSettings = externalSettings;

    });
  }

  protected getInstructionClass(data: InstructionData, index: number) : string{
    if (data.style && (typeof data.style[index] !== undefined)) {
      return data.style[index];
    }

    return '';
  }

  protected getClass(tipsData: TipsData, index : number) : string {
    if (tipsData && tipsData.tipsStyle) {
      if (typeof tipsData.tipsStyle[index] !== 'undefined') {
        return tipsData.tipsStyle[index];  
      }
    }
    return '';
  }  
}

